/**
 * Installs analytics tracking based on user consent.
 * 
 * This function listens for the `ucConsentEvent` dispatched by Usercentrics 
 * when the user interacts with the consent prompt. It then retrieves the 
 * current consent details and logs them to the console.
 *
 * @function installAnalytics
 */
function setupConsentCallback() {
  /**
   * Event listener for the `ucConsentEvent`.
   * 
   * This listener is triggered when the user interacts with the Usercentrics 
   * consent prompt. It retrieves the current consent details from the event 
   * and logs them to the console.
   *
   * @param {Event} event - The `ucConsentEvent` object containing consent details.
   */
  window.addEventListener("ucConsentEvent", (event) => {
    /**
     * The current consent details.
     * 
     * This object contains information about the user's consent choices, 
     * as provided by Usercentrics.
     * 
     * @type {Object}
     */
    let currentConsent = event.detail;

    if (haveValidConsent(currentConsent)) {
      installAdobeAnalytics();
    } else {
      console.info("User has not given valid consent. Analytics disabled.");
    }
  });
}

/** 
 * Checks if the user has given valid consent needed for analytics.
 * 
 * @param {object} ucConsentStatus object
 * @returns {boolean} if the consent is valid
 */
function haveValidConsent(ucConsentStatus) {
  const explicitConsent = ucConsentStatus['type'] === 'explicit';
  const adobeEnabled = ucConsentStatus['Adobe Analytics'] === true;

  return explicitConsent && adobeEnabled;
}

function installAdobeAnalytics() {
  const scriptTag = document.createElement('script');
    scriptTag.src = `${getAssetPath()}/includes/analytics/inline-tracking.js`;
    scriptTag.type = 'text/javascript';
    scriptTag.dataset.usercentrics='Adobe Analytics';
    scriptTag.onload = () => initializeAnalytics();
    document.body.insertAdjacentElement('beforeend', scriptTag);
}

function initializeAnalytics() {
  if ('ttt' in window) {
    window.ttt.init(getAnalyticsEnv(), {clearParams: true});
    const propChannel = document.querySelector('meta[name="tracking-channel"]');
    const pageName = document.querySelector('meta[name="tracking-page"]');

    if (propChannel && pageName) {
      window.ttt.pageview(propChannel.content, pageName.content, {});
      installClickHandlers();
    } else {
      console.log('Unable to initialize tracking. Meta tags not found.');
    }
  }
}

function getAnalyticsEnv() {
  const hostname = window.location.hostname;
  if (hostname.includes('xing.com') && hostname.includes('preview')) {
    return 'preview';
  } else if (hostname.includes('xing.com')) {
    return 'production';
  } else {
    return 'development';
  }
}

function installClickHandlers() {
  console.log(document.readyState);
  const clickElements =  document.querySelectorAll('[data-track="click"]');
  clickElements.forEach(element => {
    element.addEventListener('click', (e) => {
      const analyticsAction = element.dataset.analyticsAction;
      const analyticsOrigin = element.dataset.analyticsOrigin;
      const hasValidParams = (analyticsAction !== undefined && analyticsOrigin !== undefined);

      if (hasValidParams) {
        window.ttt?.event('PropTrackAction', {
          PropTrackAction: analyticsAction,
          PropActionOrigin: analyticsOrigin,
        });
      } else {
        console.error('Missing data-analytics-action or data-analytics-origin attribute');
      }
    });
  });

  const consentPromptLink = document.getElementById('consent-prompt');
  if(consentPromptLink !== null){
    consentPromptLink.onclick = () => {
    window.UC_UI.showSecondLayer();;
    };
  }
}

function getAssetPath(){
  try {
    const themeUri = document.querySelector('meta[name="wordpress-assets"]').content;
    return themeUri;
  } catch (error) {
    console.error('wordpress-assets meta tag not found.');
  }
}

function validAnalyticsEnvironment() {
  return window.location.hostname.includes('xing.com');
}

function installConsentManagementPlatform() {
  if (validAnalyticsEnvironment()) {
    // Install Usercentrics Loader
    const loader = document.createElement('script');
    loader.id = "usercentrics-cmp";
    loader.src = "https://app.usercentrics.eu/browser-ui/latest/loader.js";
    loader.async = true;
    loader.setAttribute('data-tcf-enabled', 'true');
    loader.setAttribute('data-avoid-prefetch-services', 'true');
    loader.setAttribute('data-nscript', 'afterInteractive', 'true');
    loader.setAttribute('data-settings-id', 'Tr_3B1GDkkB1q2');
    document.head.insertAdjacentElement('beforeend', loader);

    // Install Usercentrics Module
    const ucModule = document.createElement('script');
    ucModule.src = "https://app.usercentrics.eu/browser-ui/latest/index.module.js";
    ucModule.type = 'module';
    document.head.insertAdjacentElement('beforeend', ucModule);
  }
}

setupConsentCallback();
installConsentManagementPlatform();